export const incomeOptions = [
  { value: "salaryIncome", label: "Salary or hourly wages" },
  { value: "selfEmploymentIncome", label: "Self Employment" },
  { value: "socialIncome", label: "Social security, pension, disability" },
  { value: "otherIncome", label: "Other" },
];
